module.exports = __webpack_public_path__ + "c581bb77b915bd0b3539f9b648b0b6ac.png";